import {ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2} from '@angular/core';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {BaseFieldComponent} from '../../base/base-field/base-field.component';
import {EventDispatcherService} from '../../../events/event-dispatcher.service';
import {OptionFieldConfig} from '../option-field.config';

@Component({
    selector: 'mydocma-form-option-field',
    templateUrl: './option-field.component.html',
    styleUrls: ['./option-field.component.scss']
})
export class OptionFieldComponent extends BaseFieldComponent<OptionFieldConfig> implements OnInit {

    public readonly staticCssClass = 'mydocma-option-field';

    constructor(
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        element: ElementRef,
        renderer: Renderer2
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher,element,renderer);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    public onClick() {
        super.onControlClick();
    }

}



